"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
require("./ErrorPanel.scss");
exports.ErrorPanel = function (props) {
    var _a;
    var errorMessage = props.errorMessage, onchangeFilter = props.onchangeFilter;
    var t = react_i18next_1.useTranslation('SearchComboBox').t;
    return (react_2.default.createElement("div", { className: 'errorPanel' },
        react_2.default.createElement("span", { className: 'title' }, t('NoResult')),
        react_2.default.createElement("p", null,
            react_2.default.createElement("span", { className: 'subtitle bold' },
                t('FilterError'),
                " : "),
            react_2.default.createElement("span", { className: 'subtitle' }, errorMessage)),
        react_2.default.createElement(react_1.ActionButton, { className: 'actionButtonLink', onClick: function () {
                if (onchangeFilter) {
                    onchangeFilter();
                }
            } }, (_a = t('ChangeFilter')) !== null && _a !== void 0 ? _a : '')));
};
//# sourceMappingURL=ErrorPanel.js.map